// extracted by mini-css-extract-plugin
module.exports = {"CandidateRegistration":"WmmjLdoa","mainContainer":"_3qa7qjFQ","imageContainer":"bSt4lKDW","contentContainer":"_2rztpcWN","prevButtonContainer":"_9cO3oMw-","nextButtonContainer":"_2zBvLrPK","errorMessage":"_3O0l5QAJ","buttonContainer":"_26Pvpe_X","actionButton":"_32WVBcMu"};
    if(module.hot) {
      // 1746735766108
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  